import React from 'react';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
};

export function TranscriptionToggleButton({ isOpen, onClick, className, style }: Props) {
  return (
    <button
      className={className}
      style={{
        minWidth: '78px',
        height: '30px',
        padding: '0 12px',
        borderRadius: '9px',
        border: '1px solid rgba(255,255,255,0.14)',
        backgroundColor: isOpen ? 'rgba(255,255,255,0.11)' : 'rgba(255,255,255,0.08)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
        color: '#d5deef',
        transition: 'background-color 160ms ease, border-color 160ms ease, color 160ms ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        textTransform: 'none',
        ...style,
      }}
      onClick={onClick}
      aria-label={isOpen ? 'Hide Transcript' : 'Show Transcript'}
      title="Transcription"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="currentColor"
        style={{
          fontSize: '16px',
          width: '16px',
          height: '16px',
          flexShrink: 0,
        }}
      >
        <path d="M4 4h16v2H4zM4 8h10v2H4zM4 12h16v2H4zM4 16h10v2H4z" />
      </svg>
      <span
        style={{
          fontSize: '10px',
          fontWeight: 600,
          letterSpacing: '0.04em',
          lineHeight: 1,
        }}
      >
        transc.
      </span>
    </button>
  );
}
